import { cn } from '@/lib/utils';

/** The Deskworks mark, or the account's own logo (docs/features/branding.md) when it has one. */
export function Logo({ className, src }: { className?: string; src?: string | null }) {
  if (src) return <img src={src} alt="" className={cn('size-7 shrink-0 rounded-lg object-contain', className)} />;
  return (
    <svg viewBox="0 0 32 32" className={cn('size-7 shrink-0', className)} aria-hidden>
      <rect width="32" height="32" rx="8" className="fill-primary" />
      <g className="fill-primary-foreground">
        <rect x="8.75" y="8" width="4.5" height="16" rx="1.2" />
        <path d="M15.25 8a8 8 0 0 1 0 16v-4.5a3.5 3.5 0 0 0 0-7z" />
      </g>
    </svg>
  );
}
